import { createContext, useContext } from "react";
import AppContext from "../../../context/AppContext";
import { AGENT_ACTIONS } from "../../../utils/Constants";

/**
 * SportsbookFmContext
 * Centralizes Sportsbook FM permissions and shared state.
 * Features:
 * - Provides canEdit based on adminActions
 * - Avoids prop drilling for permission checks
 */
const SportsbookFmContext = createContext(null);

export const SportsbookFmProvider = ({ children }) => {
  const { adminActions } = useContext(AppContext);
  const canEdit = adminActions?.includes(AGENT_ACTIONS.EDIT_SPORTSBOOK_FM);

  return (
    <SportsbookFmContext.Provider value={{ canEdit }}>
      {children}
    </SportsbookFmContext.Provider>
  );
};

export const useSportsbookFm = () => {
  const ctx = useContext(SportsbookFmContext);
  if (!ctx) {
    throw new Error("useSportsbookFm must be used within a SportsbookFmProvider");
  }
  return ctx;
};

export default SportsbookFmContext;
